import { render, staticRenderFns } from "./ListaComercioExteriorEPropietario.vue?vue&type=template&id=89a7fd02&"
import script from "./ListaComercioExteriorEPropietario.vue?vue&type=script&lang=js&"
export * from "./ListaComercioExteriorEPropietario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports